import React from "react";
import ManageIncidents from "./ManageIncidents";

function ViewIncident(props) {
  return <ManageIncidents {...props} viewIncident />;
}

export default ViewIncident;
